// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { FaSearch, FaEdit, FaTrash, FaExternalLinkAlt } from "react-icons/fa";
// import AdminAppBody from "../../../../components/admin/AdminAppBody";
// import PageHeading from "../../../../components/admin/common/PageHeading";
// import useApiCallHooks from "../../../../hooks/useApiCallHooks";
// import { uiRoutes } from "../../../../routes/ui/uiRoutes";
// import { toast } from "react-toastify";

// const BlogList = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [data, setData] = useState([]);
//   const [response, loading, error, callAPI] = useApiCallHooks();

//   // Fetch Blogs
//   useEffect(() => {
//     callAPI("get", "admin/blogs");
//   }, []);

//   useEffect(() => {
//     if (response?.data) {
//       setData(response.data);
//     }
//   }, [response]);

//   const deleteRecord = (id) => {
//     if (window.confirm("Are you sure you want to delete this blog?")) {
//       callAPI("delete", `admin/blogs/${id}`);
//       toast.success("Blog deleted successfully!");
//       setData((prev) => prev.filter((item) => item.id !== id));
//     }
//   };

//   // Search filter
//   const filteredData = data?.filter(
//     (item) =>
//       item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.created_by?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="container">
//           {/* Heading */}
//           <div className="row align-items-center mb-3">
//             <div className="col-md-6">
//               <PageHeading
//                 title="Blog List"
//                 subTitle="Manage all registered Blogs."
//               />
//             </div>
//             <div className="col-md-6 text-end">
//               <Link to={uiRoutes.admin.blog.add}>
//                 <button className="btn btn-primary">Add Blog</button>
//               </Link>
//             </div>
//           </div>

//           {/* Table */}
//           <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
//             {/* Search */}
//             <div className="px-4 py-3 border-bottom bg-white">
//               <div className="row align-items-center">
//                 <div className="col-12 col-md-3 mb-3 mb-md-0">
//                   <h5 className="mb-0 fw-semibold">Blog List</h5>
//                 </div>
//                 <div className="col-12 col-md-5"></div>
//                 <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-start">
//                   <div className="input-group">
//                     <span className="input-group-text bg-white border-end-0">
//                       <FaSearch />
//                     </span>
//                     <input
//                       type="text"
//                       className="form-control border-start-0"
//                       placeholder="Search by name, description, category, or created by"
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Data Table */}
//             <div className="table-responsive">
//               <table className="table table-hover align-middle sys-list-table__content">
//                 <thead className="bg-light text-dark text-uppercase small">
//                   <tr>
//                     <th className="px-4 py-2">Sr No.</th>
//                     <th className="px-4 py-2">Name</th>
//                     <th className="px-4 py-2">Image</th>
//                     <th className="px-4 py-2">Category</th>
//                     <th className="px-4 py-2">Created By</th>
//                     <th className="px-4 py-2">Description</th>
//                     <th className="px-4 py-2 text-center">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData?.map((item, index) => (
//                     <tr key={item.id} className="sys-list-table__row border-bottom">
//                       <th className="px-4 py-2">{index + 1}</th>

//                       {/* Name */}
//                       <td className="px-4 py-2 fw-medium">{item.name}</td>

//                       {/* Image */}
//                       <td className="px-4 py-2">
//                         {item.image ? (
//                           <img
//                             src={item.image}
//                             alt={item.name}
//                             className="rounded"
//                             style={{
//                               width: "60px",
//                               height: "60px",
//                               objectFit: "cover",
//                             }}
//                           />
//                         ) : (
//                           <span className="text-muted">No Image</span>
//                         )}
//                       </td>

//                       {/* Category */}
//                       <td className="px-4 py-2">{item.category || "N/A"}</td>

//                       {/* Created By */}
//                       <td className="px-4 py-2">{item.created_by || "N/A"}</td>

//                       {/* Description */}
//                       <td
//                         className="px-4 py-2"
//                         style={{
//                           maxWidth: "250px",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           whiteSpace: "nowrap",
//                         }}
//                         title={item.description}
//                         dangerouslySetInnerHTML={{ __html: item.description }}
//                       ></td>

//                       {/* Actions */}
//                       <td className="px-4 py-2 text-center">
//                         <div className="d-flex justify-content-center gap-2">
//                           <Link
//                             to={uiRoutes.admin.blog.edit.replace(":id", item.id)}
//                           >
//                             <button
//                               className="sys-list-table__action edit"
//                               title="Edit Blog"
//                             >
//                               <FaEdit />
//                             </button>
//                           </Link>
//                           <button
//                             className="sys-list-table__action delete"
//                             title="Delete Blog"
//                             onClick={() => deleteRecord(item.id)}
//                           >
//                             <FaTrash />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                   {filteredData?.length === 0 && (
//                     <tr>
//                       <td colSpan="7" className="text-center py-3">
//                         No Blogs found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default BlogList;


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaEdit } from "react-icons/fa";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
import { toast } from "react-toastify";

const BlogList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [response, loading, error, callAPI] = useApiCallHooks();

  // Fetch Blogs
  useEffect(() => {
    callAPI("get", "admin/blogs");
  }, []);

  useEffect(() => {
    if (response?.data) {
      setData(response.data);
    }
  }, [response]);

  // Toggle Status (Active/Inactive)
  const toggleStatus = (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1;

    // API call to update blog status
    callAPI("delete", `admin/blogs/${id}`, { status: newStatus });

    // Update local state immediately
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, status: newStatus } : item
      )
    );

    toast.success(`Blog ${newStatus === 1 ? "Activated" : "Deactivated"}!`);
  };

  // Search filter
  const filteredData = data?.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.created_by?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          {/* Heading */}
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Blog List"
                subTitle="Manage all registered Blogs."
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to={uiRoutes.admin.blog.add}>
                <button className="btn btn-primary">Add Blog</button>
              </Link>
            </div>
          </div>

          {/* Table */}
          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            {/* Search */}
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-12 col-md-3 mb-3 mb-md-0">
                  <h5 className="mb-0 fw-semibold">Blog List</h5>
                </div>
                <div className="col-12 col-md-5"></div>
                <div className="col-12 col-md-4 d-flex justify-content-md-end justify-content-start">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by name, description, category, or created by"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Data Table */}
            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2">Image</th>
                    <th className="px-4 py-2">Category</th>
                    <th className="px-4 py-2">Created By</th>
                    <th className="px-4 py-2">Description</th>
                    <th className="px-4 py-2">Status</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData?.map((item, index) => (
                    <tr
                      key={item.id}
                      className="sys-list-table__row border-bottom"
                    >
                      <th className="px-4 py-2">{index + 1}</th>

                      {/* Name */}
                      <td className="px-4 py-2 fw-medium">{item.name}</td>

                      {/* Image */}
                      <td className="px-4 py-2">
                        {item.image ? (
                          <img
                            src={item.image}
                            alt={item.name}
                            className="rounded"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <span className="text-muted">No Image</span>
                        )}
                      </td>

                      {/* Category */}
                      <td className="px-4 py-2">{item.category || "N/A"}</td>

                      {/* Created By */}
                      <td className="px-4 py-2">{item.created_by || "N/A"}</td>

                      {/* Description */}
                      <td
                        className="px-4 py-2"
                        style={{
                          maxWidth: "250px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={item.description}
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      ></td>

                      {/* Status */}
                      <td className="px-4 py-2">
                        {item.status === 1 ? (
                          <span className="badge bg-success">Active</span>
                        ) : (
                          <span className="badge bg-secondary">Inactive</span>
                        )}
                      </td>

                      {/* Actions */}
                      <td className="px-4 py-2 text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Link
                            to={uiRoutes.admin.blog.edit.replace(":id", item.id)}
                          >
                            <button
                              className="sys-list-table__action edit"
                              title="Edit Blog"
                            >
                              <FaEdit />
                            </button>
                          </Link>

                          {/* Toggle Button */}
                          <button
                            className={`sys-list-table__action ${
                              item.status === 1
                                ? "btn-success"
                                : "btn-secondary"
                            }`}
                            title={
                              item.status === 1 ? "Set Inactive" : "Set Active"
                            }
                            onClick={() => toggleStatus(item.id, item.status)}
                          >
                            {item.status === 1 ? "Active" : "Inactive"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {filteredData?.length === 0 && (
                    <tr>
                      <td colSpan="8" className="text-center py-3">
                        No Blogs found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default BlogList;
